import {
    Alert,
    Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Descriptions,
    Divider,
    Form,
    message,
    Modal,
    Row,
    Select,
    Space,
    Switch,
    Table,
    Tag,
    Typography
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { useSelector } from 'react-redux';
import { currencyFormat, numFormat } from '../../Utils/formatCurrency';
import { UnorderedListOutlined } from '@ant-design/icons';
import moment from 'moment';
import { exportUserPosToExcel } from './exportMemberExcel';


function ListMembership() {
    const token = useSelector((state) => state.user.token);
    const { RangePicker } = DatePicker;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isModalConfirmStatus, setIsModalConfirmStatus] = useState(false);
    const [selectedStatusAction, setSelectedStatusAction] = useState(null);
    const [form] = Form.useForm();
    const [load, setLoad] = useState(0);
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [isModalStatus, setIsModalStatus] = useState(false);
    const [statusActive, setStatusActive] = useState();
    const [detail, setDetail] = useState(null);
    const [transData, setTransData] = useState([]);
    const [selectedPhones, setSelectedPhones] = useState([]);
    const [totalStatus, setTotalStatus] = useState({
        on: 0,
        off: 0,
        total: 0,
    });

    const [isExportModal, setIsExportModal] = useState(false);
    const [outlets, setOutlets] = useState([]);
    const [loadingOutlet, setLoadingOutlet] = useState(false);

    const [exportFilter, setExportFilter] = useState({
        outletIds: [],
        dateRange: null,
    });

    const [sort, setSort] = useState({
        sortField: 'id',
        sortOrder: 'DESC',
    });

    const titlePage = 'User';

    const openConfirmStatusModal = (isUsed) => {
        if (selectedPhones.length === 0) {
            message.warning("Pilih minimal 1 data!");
            return;
        }

        setSelectedStatusAction(isUsed);
        setIsModalConfirmStatus(true);
    };

    const getTotalStatus = () => {
        const dataReq = {
            method: "GET",
            url: '/userstatus/total',
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                setTotalStatus({
                    on: res.on || 0,
                    off: res.off || 0,
                    total: res.total || 0,
                });
            }
        }).catch(() => {
            message.error("Gagal mengambil total status!");
        });
    };

    const updateSelectedStatus = (isUsed) => {
        if (selectedPhones.length === 0) {
            message.warning("Pilih minimal 1 data!");
            return;
        }

        setLoading(true);

        const dataReq = {
            method: "POST",
            url: '/userstatus/bulk',
            data: {
                data: selectedPhones.map(phone => ({
                    phone,
                    is_used: isUsed
                })),
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        apiCall(dataReq).then((res) => {
            setLoading(false);
            setIsModalConfirmStatus(false);

            if (res.status === 200) {
                message.success("Status member berhasil diubah!");

                setData(prev =>
                    prev.map(item =>
                        selectedPhones.includes(item.mobile)
                            ? { ...item, IsUsed: isUsed }
                            : item
                    )
                );

                setSelectedPhones([]);
                setSelectedStatusAction(null);
                getTotalStatus();
            } else {
                message.error("Gagal update status!");
            }
        }).catch(() => {
            setLoading(false);
            setIsModalConfirmStatus(false);
            message.error("Gagal update status!");
        });
    };

    const columns = [
        {
            title: '',
            dataIndex: 'checkbox',
            render: (text, record) => (
                <Checkbox
                    checked={selectedPhones.includes(record.mobile)}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedPhones(prev => [...prev, record.mobile]);
                        } else {
                            setSelectedPhones(prev => prev.filter(phone => phone !== record.mobile));
                        }
                    }}
                />
            ),
        },
        {
            title: 'No',
            dataIndex: 'no',
            sorter: false,
            render: (text, record, index) =>
                (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
        },
        {
            title: 'Nama',
            dataIndex: 'name',
            key: "name",
            sorter: true,
        },
        {
            title: 'Nomor Telp',
            dataIndex: 'mobile',
            key: "mobile",
            sorter: false,
            render: (text, record) => (record.mobile ? `0${record.mobile}` : null),
        },
        {
            title: 'Status',
            dataIndex: 'IsUsed',
            key: 'IsUsed',
            sorter: false,
            render: (text, record) => (
                record.IsUsed === false
                    ? <Tag color="red">OFF / Tidak Aktif</Tag>
                    : <Tag color="green">ON / Aktif</Tag>
            ),
        },
        {
            title: 'Point',
            dataIndex: 'PointBalance',
            key: "PointBalance",
            sorter: true,
            render: (text, record) =>
                record.PointWallet ? `${numFormat(record.PointWallet.PointBalance)} Point` : `0 Point`,
        },
        {
            title: 'Role',
            dataIndex: 'Roles',
            key: "Roles",
            sorter: false,
            render: (text, record) => (record.MS_Role ? record.MS_Role.Roles : '-'),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => getApi('/user/' + record.id, 'detail')}
                        >
                            <UnorderedListOutlined />
                            <b style={{ marginLeft: 5 }}>Detail</b>
                        </Button>

                        <Button
                            type="dashed"
                            style={{ marginRight: 10 }}
                            onClick={() => openModal(record)}
                        >
                            <b style={{ marginLeft: 5 }}>On/Off</b>
                        </Button>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        const { current, pageSize } = page.pagination;
        const { sortField, sortOrder } = sort;
        const url = `/user?role=3&search=${search}&page=${current}&limit=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}`;
        getOutlets();
        getApi(url, 'all');
        getTotalStatus();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(page),
        isAlert,
        load,
    ]);

    const getOutlets = async () => {
        setLoadingOutlet(true);

        const dataReq = {
            method: "GET",
            url: "/pos/outlet?page=1&limit=1000",
            data: {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        };

        try {
            const res = await apiCall(dataReq);
            if (res.status === 200) {
                const outletRows = Array.isArray(res.data)
                    ? []
                    : res.data?.rows || [];

                setOutlets(outletRows);
            } else {
                message.error("Gagal mengambil data outlet");
            }
        } catch (error) {
            console.error(error);
            message.error("Gagal mengambil data outlet");
        } finally {
            setLoadingOutlet(false);
        }
    };

    const getApi = (url, type, exportMeta = null) => {
        setLoading(true);

        const dataReq = {
            method: "GET",
            url,
            data: {
                headers: {
                    Authorization: "Bearer " + token,
                },
            },
        };

        apiCall(dataReq)
            .then(async (res) => {
                if (res.status === 200) {
                    switch (type) {
                        case "all":
                            setData(res.data.list);

                            setPage((prev) => ({
                                ...prev,
                                pagination: {
                                    ...prev.pagination,
                                    total: res.data.pagination.total,
                                },
                            }));
                            break;

                        case "detail":
                            setTransData(res.data.transactions);
                            setDetail(res.data);
                            setIsModal(true);
                            break;

                        case "excel":
                            await exportUserPosToExcel(
                                res.data?.rows || [],
                                exportMeta
                            );

                            message.success(
                                "Data berhasil diexport"
                            );

                            setIsExportModal(false);
                            break;

                        default:
                            break;
                    }
                } else {
                    message.error(
                        res.message || "Request gagal"
                    );
                }
            })
            .catch((error) => {
                console.error(error);

                message.error(
                    error?.message || "Terjadi kesalahan"
                );
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const { current, pageSize } = pagination;
        const sortField = sorter.field || 'id';
        const sortOrder = sorter.order === 'ascend' ? 'ASC' : 'DESC';

        setPage((prev) => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current,
                pageSize,
            },
        }));

        setSort({ sortField, sortOrder });
        setLoad(load + 1);
    };

    const searchData = (value) => {
        setSearch(value);
        setLoad(load + 1);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    const openModal = (value) => {
        const status = value.IsUsed !== false;

        setStatusActive(status);
        setDetail(value);
        setIsModalStatus(true);

        form.setFieldsValue({
            statusActive: status
        });
    };

    const closeModal = () => {
        setIsModalStatus(false);
        setIsModal(false);
        setDetail(null);
        setTransData([]);
        setLoading(false);
    };

    const handleSearch = (value) => {
        const txSearch = value.toLowerCase();

        const filteredTransactions = detail.transactions.filter((transaction) =>
            transaction.transaction_code.toLowerCase().includes(txSearch)
        );

        setTransData(filteredTransactions);
    };

    const saveStatus = () => {
        if (!detail?.mobile) {
            message.error("Nomor telepon tidak ditemukan!");
            return;
        }

        setLoading(true);

        const dataReq = {
            method: "POST",
            url: '/userstatus',
            data: {
                data: {
                    phone: detail.mobile,
                    is_used: statusActive
                },
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        apiCall(dataReq).then((res) => {
            setLoading(false);

            if (res.status === 200) {
                setData(prev =>
                    prev.map(item =>
                        item.mobile === detail.mobile
                            ? { ...item, IsUsed: statusActive }
                            : item
                    )
                );

                message.success("Status berhasil diubah!");
                getTotalStatus();
                closeModal();
            } else {
                message.error("Tidak bisa tersimpan!");
            }
        }).catch(() => {
            setLoading(false);
            message.error("Tidak bisa tersimpan!");
        });
    };

    const openExportModal = () => {
        setIsExportModal(true);

        if (outlets.length === 0) {
            getOutlets();
        }
    };

    const handleExport = () => {
        const { outletIds, dateRange } = exportFilter;

        if (!outletIds?.length) {
            message.warning("Pilih minimal satu outlet");
            return;
        }

        if (!dateRange?.[0] || !dateRange?.[1]) {
            message.warning("Pilih periode tanggal");
            return;
        }

        const startDate = dateRange[0].format("YYYY-MM-DD");
        const endDate = dateRange[1].format("YYYY-MM-DD");

        const selectedOutletNames = outlets
            .filter((outlet) =>
                outletIds
                    .map(Number)
                    .includes(Number(outlet.outlet_id))
            )
            .map((outlet) => outlet.outlet_name);

        const params = new URLSearchParams({
            outlet_ids: outletIds.join(","),
            start_date: startDate,
            end_date: endDate,
        });

        const exportMeta = {
            outletIds,
            outletNames: selectedOutletNames,
            startDate,
            endDate,
        };

        getApi(
            `/userpos?${params.toString()}`,
            "excel",
            exportMeta
        );
    };

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => closeModal(false)}
                />
            )}

            <h3>Daftar Membership</h3>
            <Button
                style={{ marginBottom: 10, marginRight: 10 }}
                type="primary"
                onClick={openExportModal}
            >
                <b style={{ marginLeft: 5 }}>Export</b>
            </Button>

            <Search
                placeholder="Pencarian"
                allowClear
                enterButton="Search"
                size="medium"
                onSearch={searchData}
                style={{ marginBottom: 10, width: 300 }}
            />

            <Row gutter={16} style={{ marginBottom: 15 }}>
                <Col xs={24} sm={8}>
                    <Card size="small">
                        <b>Total Member</b>
                        <h2 style={{ margin: 0 }}>
                            {numFormat(totalStatus.total)}
                        </h2>
                    </Card>
                </Col>

                <Col xs={24} sm={8}>
                    <Card size="small">
                        <b>Total Member Active (ON)</b>

                        <h2 style={{ margin: 0, color: "#52c41a" }}>
                            {numFormat(totalStatus.on)}
                        </h2>

                        <Tag color="green">
                            Member Aktif
                        </Tag>
                    </Card>
                </Col>

                <Col xs={24} sm={8}>
                    <Card size="small">
                        <b>Total Member Non Active (OFF)</b>

                        <h2 style={{ margin: 0, color: "#ff4d4f" }}>
                            {numFormat(totalStatus.off)}
                        </h2>

                        <Tag color="red">
                            Member Non Aktif
                        </Tag>
                    </Card>
                </Col>
            </Row>

            <Space style={{ marginBottom: 10 }}>
                <Button
                    type="primary"
                    disabled={selectedPhones.length === 0}
                    onClick={() => openConfirmStatusModal(true)}
                >
                    Aktifkan
                </Button>

                <Button
                    danger
                    disabled={selectedPhones.length === 0}
                    onClick={() => openConfirmStatusModal(false)}
                >
                    Nonaktifkan
                </Button>

                <Tag color="blue">Dipilih: {selectedPhones.length}</Tag>
            </Space>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey={(record) => record.id || record.mobile}
            />

            <Modal
                title="Detail Transaksi"
                open={isModal}
                onCancel={closeModal}
                footer={null}
                width={800}
            >
                {isModal === true && detail && detail !== null ? (
                    <>
                        <Descriptions title="Informasi Pelanggan" bordered column={2} size="small">
                            <Descriptions.Item label="Join Date">
                                {moment(detail.created_at).format('YYYY-MM-DD HH:mm:ss')}
                            </Descriptions.Item>
                            <Descriptions.Item label="Kode Customer">
                                {detail.code_customer || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Nama">
                                {detail.name}
                            </Descriptions.Item>
                            <Descriptions.Item label="Email">
                                {detail.email || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Telepon">
                                {detail.phone}
                            </Descriptions.Item>
                            <Descriptions.Item label="Total Poin">
                                <Tag color="blue">
                                    {Number(detail.point).toLocaleString()} Poin
                                </Tag>
                            </Descriptions.Item>
                        </Descriptions>

                        <Space style={{ marginTop: 20, marginBottom: 10, width: "100%" }}>
                            <Search
                                placeholder="Cari Kode Transaksi..."
                                onChange={(e) => handleSearch(e.target.value)}
                                enterButton
                                allowClear
                            />
                        </Space>

                        <div style={{ maxHeight: 400, overflowY: "auto", paddingRight: 10 }}>
                            {transData.length > 0 && transData.map((transaction, index) => (
                                <div key={index} style={{ marginTop: 20 }}>
                                    <Typography.Title level={5}>
                                        Transaksi: {transaction.transaction_code}
                                    </Typography.Title>

                                    <Descriptions bordered column={2} size="small">
                                        <Descriptions.Item label="Tanggal">
                                            {moment(transaction.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Toko">
                                            {transaction.outlet.outlet_name}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Total Belanja">
                                            Rp {Number(transaction.grand_total).toLocaleString()}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Metode Pembayaran">
                                            {transaction.payment_method}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Alat Pembayaran">
                                            {transaction.device_payment}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Voucher">
                                            Rp {Number(transaction.voucher_price).toLocaleString()}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Poin Digunakan">
                                            <Tag color="red">
                                                {currencyFormat(Number(transaction.point_redeem))} Poin
                                            </Tag>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Poin Diperoleh">
                                            <Tag color="green">
                                                {currencyFormat(Number(transaction.point?.point) || 0)} Poin
                                            </Tag>
                                        </Descriptions.Item>
                                    </Descriptions>

                                    <Table
                                        dataSource={transaction.transaction_products}
                                        columns={[
                                            {
                                                title: "Nama Produk",
                                                dataIndex: ["product", "product_name"],
                                                key: "product_name",
                                            },
                                            {
                                                title: "Harga",
                                                dataIndex: "price",
                                                key: "price",
                                                render: (text) => currencyFormat(Number(text)),
                                            },
                                            {
                                                title: "Qty",
                                                dataIndex: "qty",
                                                key: "qty",
                                            },
                                            {
                                                title: "Subtotal",
                                                dataIndex: "subtotal",
                                                key: "subtotal",
                                                render: (text) => currencyFormat(Number(text)),
                                            },
                                        ]}
                                        size="small"
                                        pagination={false}
                                        style={{ marginTop: 10 }}
                                        rowKey={(record) => record.product.product_name}
                                        bordered
                                    />
                                </div>
                            ))}
                        </div>
                    </>
                ) : null}
            </Modal>

            <Form layout="vertical" form={form} onFinish={saveStatus}>
                <Modal
                    title="Detail Status"
                    open={isModalStatus}
                    onCancel={closeModal}
                    onOk={() => form.submit()}
                    okText="Simpan"
                    cancelText="Batal"
                >
                    {detail && (
                        <>
                            <Descriptions size="small" column={1} bordered>
                                <Descriptions.Item label="Nama">{detail.name}</Descriptions.Item>
                                <Descriptions.Item label="No Telp">{detail.mobile}</Descriptions.Item>
                            </Descriptions>

                            <Divider />

                            <Form.Item label="Status Akun" name="statusActive" valuePropName="checked">
                                <Switch onChange={(checked) => setStatusActive(checked)} />
                            </Form.Item>

                            <span style={{ marginLeft: 10 }}>
                                {statusActive === false ? "Tidak Aktif" : "Aktif"}
                            </span>

                            {statusActive === false && (
                                <Alert
                                    message="Warning"
                                    description="Customer tidak bisa menggunakan Point Member"
                                    type="warning"
                                    showIcon
                                    closable
                                    style={{ marginTop: 15 }}
                                />
                            )}
                        </>
                    )}
                </Modal>
            </Form>

            <Modal
                title={selectedStatusAction === true ? "Konfirmasi Aktifkan Member" : "Konfirmasi Nonaktifkan Member"}
                open={isModalConfirmStatus}
                onCancel={() => {
                    setIsModalConfirmStatus(false);
                    setSelectedStatusAction(null);
                }}
                onOk={() => updateSelectedStatus(selectedStatusAction)}
                okText={selectedStatusAction === true ? "Ya, Aktifkan" : "Ya, Nonaktifkan"}
                cancelText="Batal"
                confirmLoading={loading}
                okButtonProps={{
                    danger: selectedStatusAction === false
                }}
            >
                <Alert
                    type={selectedStatusAction === true ? "success" : "warning"}
                    showIcon
                    message={
                        selectedStatusAction === true
                            ? "Aktifkan Member Terpilih?"
                            : "Nonaktifkan Member Terpilih?"
                    }
                    description={
                        selectedStatusAction === true
                            ? `Sebanyak ${selectedPhones.length} member akan diaktifkan dan bisa menggunakan Point Member.`
                            : `Sebanyak ${selectedPhones.length} member akan dinonaktifkan dan tidak bisa menggunakan Point Member.`
                    }
                />
            </Modal>
            <Modal
                title="Export Transaksi Member"
                open={isExportModal}
                onCancel={() => setIsExportModal(false)}
                onOk={handleExport}
                okText="Export"
                cancelText="Batal"
                confirmLoading={loading}
                destroyOnClose
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Outlet"
                        required
                    >
                        <Select
                            mode="multiple"
                            allowClear
                            showSearch
                            placeholder="Pilih outlet"
                            loading={loadingOutlet}
                            value={exportFilter.outletIds}
                            optionFilterProp="label"
                            maxTagCount="responsive"
                            options={outlets.map((outlet) => ({
                                value: outlet.outlet_id,
                                label: outlet.outlet_name,
                            }))}
                            onChange={(values) => {
                                setExportFilter((prev) => ({
                                    ...prev,
                                    outletIds: values,
                                }));
                            }}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Periode Transaksi"
                        required
                    >
                        <RangePicker
                            style={{ width: "100%" }}
                            format="YYYY-MM-DD"
                            value={exportFilter.dateRange}
                            onChange={(dates) => {
                                setExportFilter((prev) => ({
                                    ...prev,
                                    dateRange: dates,
                                }));
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export default ListMembership;